import { useQuery } from "@tanstack/react-query";
import { UserInterface } from "../../../models/UserModel/User";
import userService from "../../../services/userService/userService";

const useUserByFirstLastname = (
  cacheKey: string,
  page: number,
  pageSize: number,
  searchTerm: string
) =>
  useQuery<UserInterface[], Error>({
    queryKey: [
      cacheKey,
      page,
      pageSize,
      searchTerm.length >= 3 || searchTerm.length === 0,
    ],
    queryFn: () => userService.GetByFirstlastName(page, pageSize, searchTerm),
  });

export default useUserByFirstLastname;
